






import Vue from "vue";
import { Component, Prop, Provide, Watch } from "vue-property-decorator";
import L, { control } from "leaflet";

import * as esri from "esri-leaflet";
import { LegendSection, LegendSymbol } from "../types";
import "../services/MapSidepaneControl.js";
import { EsriSymbol } from "../services/EsriSymbolRenderer";

@Component({})
export default class MapLegend extends Vue {
  @Prop() map!: L.Map;
  @Prop() content!: LegendSection[];
  legend!: any;

  @Watch("content")
  contentChanged() {
    if (this.legend) {
      this.legend.setContents(this.getContent());
    }
  }

  mounted() {
    //var legend = L.control.slideMenu(this.template,{position: 'topright', menuposition: 'topright', width: '275px',  delay: '50', icon: 'fa-chevron-left'});

    this.legend = L.control.mapSidebar(this.getContent(), {
      position: "topleft"
    });
    this.legend.addTo(this.map);
  }
  update() {}

  destroy() {
    this.legend.onRemove();
  }

  getContent() {
    var content = "";
    for (var t = 0; t < this.content.length; t++) {
      if (this.content[t] && this.content[t].name && this.content[t].items) {
        content +=
          '<div class="legend-title">' + this.content[t].name + "</div>";
        content += '<ul class="legend-items">';
        for (var i = 0; i < this.content[t].items.length; i++) {
          var symbolImage = this.getSymbol(this.content[t].items[i].symbol);
          content +=
            "<li><span>" +
            symbolImage +
            "</span>" +
            this.content[t].items[i].label +
            "</li>";
        }
        content += "</ul>";
      }
    }

    return content;
  }
  getSymbol(symbol: LegendSymbol) {
    if (symbol) {
      var image = "";
      var renderer = new EsriSymbol.Renderer();
      renderer.render(symbol, function(legend: string, error: string) {
        image = legend;
      });
      return image;
    }
  }
}
